import React, { Component } from 'react';
import { Col, ControlLabel, Form, FormGroup } from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import './ChangeOrderQuoteSubmitForm.css';
import Date from 'components/shared/text/Date';
import FormDateTimePicker from 'components/shared/form/FormDateTimePicker';
import { todayValidation } from 'services/utils/date-util';
import FormDropDown from 'components/shared/form/FormDropDown';
import FormInput from 'components/shared/form/FormInput';
import FormTextArea from 'components/shared/form/FormTextArea';

class ChangeOrderQuoteSubmitForm extends Component {
  static createDurationOptions() {
    const result = [];
    for (let i = 0.5; i <= 15; i = i + 0.5) {
      result.push({
        label: i + (i < 1.5 ? ' day' : ' days'),
        value: i,
      });
    }
    return result;
  }

  static createMaterialLeadDaysOptions() {
    const result = [];
    for (let i = 1; i <= 100; i = i + 1) {
      result.push({
        label: i + (i < 2 ? ' day' : ' days'),
        value: i,
      });
    }
    return result;
  }

  render() {
    return (
      <div className="change-order-quote-request-form">
        <Form horizontal onSubmit={this.props.handleSubmit}>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Target Completion Date
            </Col>
            <Col sm={8}>
              <span className="body-bold">
                <Date
                  format="LL"
                  value={this.props.changeOrderTask.completion_date}
                />
              </span>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              When can you get started?
            </Col>
            <Col sm={8}>
              <Field
                component={FormDateTimePicker}
                isValidDate={todayValidation}
                name="startDate"
                placeholder="Start Date"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              How long will it take?
            </Col>
            <Col sm={8}>
              <Field
                component={FormDropDown}
                options={ChangeOrderQuoteSubmitForm.createDurationOptions()}
                name="daysOfDuration"
                placeholder="Duration"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Material Lead Time
            </Col>
            <Col sm={8}>
              <Field
                component={FormDropDown}
                options={ChangeOrderQuoteSubmitForm.createMaterialLeadDaysOptions()}
                clearable={true}
                name="materialLeadDays"
                placeholder="Material Lead Time"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Total Cost
            </Col>
            <Col sm={8}>
              <Field
                component={FormInput}
                type="number"
                name="estimate"
                placeholder="Total Cost"
              />
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={4}>
              Description
            </Col>
            <Col sm={8}>
              <Field
                component={FormTextArea}
                name="description"
                placeholder="Is there anything the Spackle team should know, process or experience? (Please be sure to include any exclusions)."
              />
            </Col>
          </FormGroup>
          {this.props.invalid && this.props.submitFailed && (
            <div className="invalid-message">
              The outlined inputs should be added in order to submit change
              order pricing.
            </div>
          )}
          <FormGroup className="button-container">
            <Col sm={12}>
              <input
                className="btn button button-orange"
                type="submit"
                value="Submit"
              />
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.startDate) {
    errors.startDate = 'Required';
  }
  if (!values.daysOfDuration) {
    errors.daysOfDuration = 'Required';
  }
  if (!values.estimate) {
    errors.estimate = 'Required';
  }
  return errors;
}

export default reduxForm({
  form: 'ChangeOrderQuoteSubmitForm',
  validate,
})(ChangeOrderQuoteSubmitForm);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/change-order-quotes/ChangeOrderQuoteSubmitForm.js